/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class ConfigurationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<SwaggerResponse<ConfigurationViewModel>> {
        let url_ = this.baseUrl + "/appConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SwaggerResponse<ConfigurationViewModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationViewModel.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ConfigurationViewModel>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class ConfigurationViewModel {
    buildVersion?: string | undefined;
    googleMapsApiKey?: string | undefined;
    gtmContainerId?: string | undefined;
    launchDarklyClientsideId?: string | undefined;
    clientName?: string | undefined;
    newAppUrl?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.buildVersion = _data["buildVersion"];
            this.googleMapsApiKey = _data["googleMapsApiKey"];
            this.gtmContainerId = _data["gtmContainerId"];
            this.launchDarklyClientsideId = _data["launchDarklyClientsideId"];
            this.clientName = _data["clientName"];
            this.newAppUrl = _data["newAppUrl"];
        }
    }

    static fromJS(data: any): ConfigurationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildVersion"] = this.buildVersion;
        data["googleMapsApiKey"] = this.googleMapsApiKey;
        data["gtmContainerId"] = this.gtmContainerId;
        data["launchDarklyClientsideId"] = this.launchDarklyClientsideId;
        data["clientName"] = this.clientName;
        data["newAppUrl"] = this.newAppUrl;
        return data; 
    }
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}